/**
 * 现代 Viewport 适配方案
 * 替代 lib-flexible，使用 CSS 视口单位进行移动端适配
 * 设计稿基准：1920px 桌面端设计稿
 */

(function() {
  'use strict';

  // 设计稿宽度
  const DESIGN_WIDTH = 1920;
  
  // 最小和最大宽度限制
  const MIN_WIDTH = 320;
  const MAX_WIDTH = 2560;

  // 设置 CSS 自定义属性用于响应式计算
  function setViewportVariables() {
    const doc = document.documentElement;
    const clientWidth = Math.min(Math.max(doc.clientWidth, MIN_WIDTH), MAX_WIDTH);
    
    // 设置 CSS 变量
    doc.style.setProperty('--vw', clientWidth / 100 + 'px');
    doc.style.setProperty('--vh', doc.clientHeight / 100 + 'px');
    doc.style.setProperty('--design-width', DESIGN_WIDTH + 'px');
    doc.style.setProperty('--scale-ratio', clientWidth / DESIGN_WIDTH);
    
    // 设置根字体大小用于 rem 单位（如果需要兼容）
    doc.style.fontSize = (clientWidth / DESIGN_WIDTH) * 16 + 'px';
  }

  // 设置 viewport meta 标签
  function setViewportMeta() {
    let metaEl = document.querySelector('meta[name="viewport"]');
    
    if (!metaEl) {
      metaEl = document.createElement('meta');
      metaEl.setAttribute('name', 'viewport');
      document.head.appendChild(metaEl);
    }
    
    metaEl.setAttribute('content', 
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover'
    );
  }

  // 初始化函数
  function init() {
    setViewportMeta();
    setViewportVariables();
  }

  // DOM 加载完成后执行
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // 监听窗口大小变化
  let resizeTimer = null;
  window.addEventListener('resize', function() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setViewportVariables, 100);
  });
  
  // 监听屏幕旋转
  window.addEventListener('orientationchange', function() {
    setTimeout(setViewportVariables, 200);
  });

  // 暴露工具函数
  window.ViewportAdapter = {
    // px 转 vw
    px2vw: function(px) {
      return (px / DESIGN_WIDTH) * 100;
    },
    
    // px 转 vh  
    px2vh: function(px) {
      return (px / 1080) * 100; // 假设设计稿高度为 1080px
    },
    
    // 获取当前缩放比例
    getScaleRatio: function() {
      return document.documentElement.clientWidth / DESIGN_WIDTH;
    },
    
    // 获取响应式尺寸
    getResponsiveSize: function(px) {
      return px * this.getScaleRatio();
    }
  };

})();